import { xhrFetch } from "../utilities/xhrManager";
import { _addEventListener } from "../utilities/Helpers/eventHelper";
import Modal from "../utilities/Helpers/UI/Modal";
import {
    show,
    hide,
    hideAndBlockScroll,
    showAndUnlockScroll,
    blockScroll,
    unblockScroll,
} from "../utilities/Helpers/helpers";

LUC.jsProductAis = {
    isAvailableInStore: false,
    isAvailableOnline: false,
    init: function () {
        LUC.jsProductAis.openModal();
        LUC.jsProductAis.submitAisForm();
        LUC.jsProductAis.findDataByGeolocation();
        LUC.jsFAQ.init();
    },
    openModal: function () {
        const aisOpenModalBtns = document.querySelectorAll("[data-ais-btn-open-modal]");
        aisOpenModalBtns.forEach((aisOpenModalBtn) => {
            _addEventListener(aisOpenModalBtn, "click", (event) => {
                event.preventDefault();
                Modal.getModalByName("ais").delay = 500;
                Modal.getModalByName("ais").onOpened = (modal) => {
                    modal.getModalElement().classList.remove("tw-translate-x-full");
                    blockScroll();
                };
                Modal.getModalByName("ais").onClosing = (modal) => {
                    modal.getModalElement().classList.add("tw-translate-x-full");
                    unblockScroll();
                };
                Modal.getModalByName("ais").show();
                LUC.jsProductAis.getAisData();
                $("html").addClass("hidden-scroll");
            });
        });
    },

    findDataByGeolocation: function () {
        const geolocationBtnEl = document.querySelector("[data-ais-geolocation-btn]");
        const zipInputEl = document.querySelector("[data-ais-zip]");
        const discardIcon = document.querySelector("[data-ais-discard]");
        if (!geolocationBtnEl) {
            return;
        }
        geolocationBtnEl.addEventListener("click", (event) => {
            event.preventDefault();
            LUC.jsProductAis.getLocation();
            zipInputEl.value = "";
            hide(discardIcon);
        });
    },
    submitAisForm: function () {
        const submitForm = document.querySelector("[data-ais-form]");
        const formOutput = document.querySelector("[data-ais-form-output]");
        const zipInputEl = submitForm.querySelector("[data-ais-zip]");
        const discardIcon = submitForm.querySelector("[data-ais-discard]");
        const noLocationEl = document.querySelector("[data-ais-messages-no-location]");

        if (!submitForm) {
            return;
        }
        zipInputEl.setAttribute("aria-invalid", false);
        function isValidUSZip(sZip) {
            return /^\d{5}(-\d{4})?$/.test(sZip);
        }
        if (discardIcon) {
            discardIcon.addEventListener("click", function (e) {
                e.preventDefault();
                zipInputEl.value = "";
                hide(discardIcon);
                hide(noLocationEl);
                LUC.jsProductAis.getAisData();
            });
        }
        zipInputEl.addEventListener("keydown", function () {
            zipInputEl.setAttribute("aria-invalid", false);
            if (zipInputEl.value.length > 0) {
                show(discardIcon);
                if (isValidUSZip(zipInputEl.value)) {
                    formOutput.innerHTML = "Invalid Zip Code";
                    zipInputEl.setAttribute("aria-invalid", true);
                } else {
                    formOutput.innerHTML = "";
                }
            } else {
                hide(discardIcon);
            }
        });
        submitForm.addEventListener("submit", (evt) => {
            evt.preventDefault();
            zipInputEl.setAttribute("aria-invalid", false);
            if (zipInputEl.value && zipInputEl.value.length > 2) {
                formOutput.innerHTML = "";
                if (isValidUSZip(zipInputEl.value)) {
                    LUC.jsProductAis.getAisData(zipInputEl.value);
                    LUC.jsProductAis.displayMessage("empty");
                    const noLocationEl = document.querySelector("[data-ais-messages-no-location]");
                    hide(noLocationEl);
                } else {
                    formOutput.innerHTML = "Invalid Zip Code";
                    zipInputEl.setAttribute("aria-invalid", true);
                }
            } else {
                formOutput.innerHTML = "You have to fill a Zip code field";
                zipInputEl.setAttribute("aria-invalid", true);
            }
        });
    },
    checkAvailabilityForCTO(productId) {
        const variantId = document.querySelector(".product-" + productId + ' .shopify-product-form [name="id"]');
        const callToOrderEl = document.querySelector("[data-section-cto]");
        const callToOrderInfo = document.querySelectorAll(".product-" + productId + " [data-cto-info]");
        const notifyMeBtn = document.querySelectorAll(".product-" + productId + " [data-notify-me-btn]");
        const klaviyoBisBtn = document.querySelector(".klaviyo-bis-trigger");
        const loaderEl = document.querySelector("[data-basic-loader]");
        const chooseSizeContentEl = document.querySelector("[data-choose-size-content]");

        LUC.jsProductAis.isAvailableInStore = false;

        const apiUrl = LUC.jsProductAis.getApiUrl();
        if (loaderEl) {
            loaderEl.classList.add("active");
        }
        xhrFetch(
            `${apiUrl}/inventory/${variantId.value}`,
            {
                method: "GET",
            },
            (response) => {
                if (response.data.length > 0) {
                    response.data.forEach((item) => {
                        if (item.available) {
                            LUC.jsProductAis.isAvailableInStore = true;
                        }
                    });
                }
                if (!LUC.jsProductAis.isAvailableOnline && LUC.jsProductAis.isAvailableInStore) {
                    show(callToOrderEl);
                    callToOrderInfo.forEach((item) => {
                        show(item);
                    });
                    hide(klaviyoBisBtn, true);
                    notifyMeBtn.forEach((item) => {
                        hide(item);
                    });
                    chooseSizeContentEl?.classList.add("tw-pb-44");
                } else {
                    callToOrderInfo.forEach((item) => {
                        hide(item);
                    });
                    hide(callToOrderEl);
                    chooseSizeContentEl?.classList.remove("tw-pb-44");
                }
                if (loaderEl) {
                    loaderEl.classList.remove("active");
                }
            },
            (exception) => {
                console.log(exception);
            }
        );
    },
    getAisData: async function (zipCode) {
        const listEl = document.querySelector("[data-ais-stores]");
        const variantId = document.querySelector('.shopify-product-form [name="id"]');
        const apiUrl = LUC.jsProductAis.getApiUrl();
        const formOutput = document.querySelector("[data-ais-form-output]");
        let zipCodeParam = "";
        LUC.jsProductAis.addLoader(listEl);
        if (zipCode) {
            zipCodeParam = "?zipcode=" + zipCode;
        }
        xhrFetch(
            `${apiUrl}/inventory/${variantId.value}${zipCodeParam}`,
            {
                method: "GET",
            },
            (response) => {
                LUC.jsProductAis.displayAisData(response, listEl);
                LUC.jsProductAis.displayMessage("empty");
            },
            (exception) => {
                console.log(exception);
                formOutput.innerText = exception.message;
                LUC.jsProductAis.removeLoader(listEl);
                LUC.jsProductAis.displayMessage("empty");
            }
        );
    },
    getStoresByLocation: async function (lat, lng) {
        const listEl = document.querySelector("[data-ais-stores]");
        const variantId = document.querySelector('.shopify-product-form [name="id"]');
        const apiUrl = LUC.jsProductAis.getApiUrl();
        let hasStores = false;
        LUC.jsProductAis.addLoader(listEl);
        xhrFetch(
            `${apiUrl}/inventory/${variantId.value}?lat=${lat}&lng=${lng}`,
            {
                method: "GET",
            },
            (response) => {
                const filteredData = { data: [] };
                response.data.forEach((item) => {
                    if (item.distance < 100) {
                        filteredData.data.push(item);
                        hasStores = true;
                    } else {
                        hasStores = false;
                    }
                });
                if (filteredData.data.length === 0) {
                    response.data.forEach((item, index) => {
                        if (index < 3) {
                            filteredData.data.push(item);
                        }
                    });
                }
                const zipInput = document.querySelector("[data-ais-zip]");
                if (zipInput) {
                    zipInput.value = response.meta.zip;
                    if (zipInput.value != "") {
                        const discardIcon = document.querySelector("[data-ais-discard]");
                        show(discardIcon);
                    }
                }
                if (hasStores) {
                    LUC.jsProductAis.displayMessage("empty");
                } else {
                    LUC.jsProductAis.displayMessage("notFoundStores");
                }
                LUC.jsProductAis.displayAisData(filteredData, listEl);
            },
            () => {
                console.log("The request failed!");
                LUC.jsProductAis.displayMessage("error");
                LUC.jsProductAis.removeLoader(listEl);
            }
        );
    },
    displayAisData: function (data, listEl) {
        listEl.innerHTML = "";
        if (data.data.length > 0) {
            data.data.forEach((item, index) => {
                listEl.innerHTML =
                    listEl.innerHTML +
                    `
                <dl><dt class="tw-font-brandonGrotesque tw-py-1">
                    <button class="focus:tw-border-navy focus:tw-shadow-input-focus accordion-style--carets accordion__button" type="button" aria-controls="panel-ais-${index}" aria-expanded="false">
                        <span>
                            <span class="head">${item.city}</span>
                            <span class="subhead">${item.title.toLowerCase()}</span>
                        </span>
                        <span class="accordion__icon tw-flex tw-items-center tw-justify-center tw-w-12 tw-h-12 tw-absolute tw-right-0 tw-top-0 tw-bottom-0 tw-my-auto">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                                <path d="M19.5 9L12 16.5L4.5 9" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                        </span>
                        <span class="availability ${item.available == true ? "" : "unavailable"}">
                            ${
                                item.available == true
                                    ? `
                                <span class="icon-available" data-icon="available">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                                    <path d="M16.125 9.75L10.6219 15L7.875 12.375" stroke="#147D12" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z" stroke="#147D12" stroke-linecap="round" stroke-linejoin="round"/>
                                    </svg>
                                </span>
                                Available <span class="cto-available tw-text-md tw-leading-md tw-text-neutrals-90 tw-relative tw-pl-4">Call to Order</span>
                            `
                                    : `
                                <span class="icon-unavailable" data-icon="unavailable">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                                    <path d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z" stroke="#A91919" stroke-miterlimit="10"/>
                                    <path d="M15 9L9 15" stroke="#A91919" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M15 15L9 9" stroke="#A91919" stroke-linecap="round" stroke-linejoin="round"/>
                                    </svg>
                                </span>
                                Unavailable
                            `
                            }
                        </span>
                    </button>
                </dt>
                <dd id="panel-ais-${index}" aria-hidden="true">
                    <div class="content">
                        <div class="address">
                            <a target="_blank" href="https://www.google.com/maps/place/${encodeURIComponent(item.address_line + " " + item.city + " " + item.zip)}" aria-label="Show directions to ${item.address_line} ${item.city}, ${item.state} ${item.zip}" title="${item.address_line} ${item.city}, ${item.state} ${item.zip} on Google Maps">
                                <p>${item.address_line}</p>
                                <p>${item.city}, ${item.state} ${item.zip}</p>
                            </a>
                        </div>
                        <div class="phone">
                            <p class="head">Phone: <span><a href="tel:${item.phone}">${item.phone}</a></span></p>
                            <div class="ais__cto-info ${item.available == true ? "" : "unavailable"}"><span class="icon" data-icon="phone">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true">
<path d="M8.67187 11.7C9.44364 13.2938 10.7324 14.5792 12.3281 15.3469C12.4458 15.4026 12.576 15.4268 12.7059 15.4169C12.8358 15.407 12.9608 15.3635 13.0687 15.2907L15.4125 13.725C15.516 13.6548 15.6357 13.6119 15.7603 13.6005C15.8849 13.589 16.0104 13.6093 16.125 13.6594L20.5125 15.5438C20.6625 15.6062 20.7877 15.7162 20.869 15.8568C20.9504 15.9974 20.9832 16.1608 20.9625 16.3219C20.8234 17.4073 20.2937 18.4048 19.4723 19.1278C18.6509 19.8508 17.5943 20.2498 16.5 20.25C13.1185 20.25 9.87548 18.9067 7.48439 16.5156C5.0933 14.1246 3.75 10.8815 3.75 7.50003C3.75025 6.40578 4.1492 5.34911 4.87221 4.52774C5.59522 3.70637 6.59274 3.17659 7.67812 3.03753C7.83922 3.01684 8.00266 3.04967 8.14326 3.13099C8.28386 3.2123 8.39384 3.33758 8.45625 3.48753L10.3406 7.88441C10.3896 7.99723 10.4101 8.12038 10.4003 8.24299C10.3905 8.36561 10.3507 8.48393 10.2844 8.58753L8.71875 10.9688C8.64905 11.0765 8.60814 11.2003 8.59993 11.3283C8.59172 11.4563 8.61649 11.5843 8.67187 11.7V11.7Z" stroke="#0C2752" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
                            </span> <span class="">Call to order item</span></div>
                        </div>
                        <p class="head">Store hours:</p>
                        <div class="store-hours tw-mt-1">
                            ${Object.keys(item.store_hours)
                                .map(
                                    (key, index, arr) => `
                                <p class="tw-flex tw-align-items tw-font-brandonGrotesque tw-justify-between tw-w-full tw-text-center">
                                    <span class="tw-flex tw-items-center tw-justify-center tw-h-14 tw-bg-neutrals-10 tw-px-2.5 tw-py-3 tw-basis-24 tw-text-base tw-text-md tw-leading-md tw-text-black">
                                        ${key}:
                                    </span>
                                    <span class="tw-flex tw-items-center tw-justify-center tw-h-14 tw-bg-neutrals-10 tw-px-2.5 tw-py-3 tw-basis-72 tw-text-base tw-text-md tw-leading-md tw-text-black"> 
                                        ${item.store_hours[key].start} - ${item.store_hours[key].end}
                                    </span>
                                </p>
                            `
                                )
                                .join("")}
                        </div>
                        <a href="tel:${item.phone}" class="ais__button medium-up:tw-hidden !tw-no-underline tw-flex tw-bg-secondary tw-mt-2 tw-h-12 tw-justify-center tw-tracking-wide tw-hover:tw-opacity-80 tw-font-brandonGrotesque tw-font-normal tw-items-center ${item.available == true ? "" : "hide"}">
                            <span class="tw-text-white tw-pr-2.5 tw-flex tw-flex-row" data-icon="phone">
                                <svg class="tw-h-6 tw-w-6 tw-min-w-fit" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                                    <g id="Phone">
                                        <path id="Vector" d="M8.67187 11.7C9.44364 13.2938 10.7324 14.5792 12.3281 15.3469C12.4458 15.4026 12.576 15.4268 12.7059 15.4169C12.8358 15.407 12.9608 15.3635 13.0687 15.2907L15.4125 13.725C15.516 13.6548 15.6357 13.6119 15.7603 13.6005C15.8849 13.589 16.0104 13.6093 16.125 13.6594L20.5125 15.5438C20.6625 15.6062 20.7877 15.7162 20.869 15.8568C20.9504 15.9974 20.9832 16.1608 20.9625 16.3219C20.8234 17.4073 20.2937 18.4048 19.4723 19.1278C18.6509 19.8508 17.5943 20.2498 16.5 20.25C13.1185 20.25 9.87548 18.9067 7.48439 16.5156C5.0933 14.1246 3.75 10.8815 3.75 7.50003C3.75025 6.40578 4.1492 5.34911 4.87221 4.52774C5.59522 3.70637 6.59274 3.17659 7.67812 3.03753C7.83922 3.01684 8.00266 3.04967 8.14326 3.13099C8.28386 3.2123 8.39384 3.33758 8.45625 3.48753L10.3406 7.88441C10.3896 7.99723 10.4101 8.12038 10.4003 8.24299C10.3905 8.36561 10.3507 8.48393 10.2844 8.58753L8.71875 10.9688C8.64905 11.0765 8.60814 11.2003 8.59993 11.3283C8.59172 11.4563 8.61649 11.5843 8.67187 11.7V11.7Z" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
                                    </g>
                                </svg>
                            </span> <span class="tw-text-white ">CALL TO ORDER</span>
                        </a>
                    </div>
                </dd></dl>
                `;
            });

            LUC.jsFAQ.init();
        }
    },
    displayMessage: function (messageKey) {
        const messages = {
            empty: "",
            emptyZipCode: "You have to fill a Zip code field",
            incorrectZipcode: "Incorrect Zip code",
            geolocationStores: "Your nearest stores:",
            notFoundStores: "There are no stores within 100 miles from your location",
            geolocationNotSupported: "Geolocation is not supported by this browser.",
            error: "Not Expected Error",
        };
        const messageEl = document.querySelector("[data-ais-messages]");
        if (!messageEl) {
            return;
        }
        if (messageKey == "notFoundStores") {
            const noLocationEl = document.querySelector("[data-ais-messages-no-location]");
            show(noLocationEl);
        } else {
            messageEl.innerHTML = `<p>${messages[messageKey]}</p>`;
        }
    },
    getLocation: function () {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(showPosition);
        } else {
            LUC.jsProductAis.displayMessage("geolocationNotSupported");
        }
        function showPosition(position) {
            LUC.jsProductAis.getStoresByLocation(position.coords.latitude, position.coords.longitude);
        }
    },
    getApiUrl: function () {
        let apiUrl = "https://ais.lucchese.com";
        if (window.location.host === "lucchese-staging.myshopify.com") {
            apiUrl = "https://ais-staging.lucchese.com";
        }

        return apiUrl;
    },
    addLoader: function (node) {
        node.innerHTML = '<div class="wishlist__loader active"></div>';
    },
    removeLoader: function (node) {
        node.innerHTML = "";
    },
    unload: function () {},
};
